/* eslint-disable */
import { Component } from 'react';
import { Trans } from 'Helpers';
import { Modal, ModalBody, ModalFooter } from 'reactstrap'
import {Images} from 'Helpers';

class GameOnModal extends Component {
  render() {
    const {isOpen, joinMore, goToHome} = this.props
    
    
    return (
      <Modal  isOpen={isOpen} size='sm' centered className='confirmation-modal width-modal game-on'>
        {/* <div onClick={toggle} className='close-btn'>
          <i className="icon-cancel"/>
        </div> */}
        <div className='confirm-header'>
          <div className='image-wrapper'>
            <div className='image-outer'>
              <img src={Images.CONFIRM} alt="" />
            </div>
          </div>
        </div>
        <h4 className='confrim-head'><Trans>Game On!</Trans></h4>
        <ModalBody>
          <div className="game-onbody">
            <Trans>Your team has been submitted successfully.</Trans>
          </div>
        </ModalBody>
        <ModalFooter className='joined-confimation-footer'>
          <button onClick={()=>goToHome()} className='btn  btn-primary'><Trans>Go to Home</Trans></button>
          <button onClick={()=>joinMore()} className='btn  btn-primary'><Trans>Go to Lobby</Trans></button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default GameOnModal;
